import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EmpresaService } from '../../services/empresa.service';
import { ToastService } from '../../services/toast.service';
import { Instancia } from '../../types/Instancia.type';

@Component({
  selector: 'app-empresa-dropdown',
  templateUrl: './empresa-dropdown.component.html',
  styleUrl: './empresa-dropdown.component.css'
})
export class EmpresaDropdownComponent implements OnInit{
  @Input() selecionadas: string = ""
  @Input() multiplo: boolean = true
  @Input() modo: 'unico' | 'multiplo' = "multiplo" 

  @Output() selecionadasChange = new EventEmitter<any>();
  @Output() onPanelHide = new EventEmitter<any>();

  @Output() funcaoChange = new EventEmitter<any>();

  constructor(private empresaService: EmpresaService, private toastService: ToastService) {}

  instancias: Instancia[] = [];

  ngOnInit(): void {
    this.getInstancias();
  }

  getInstancias(){

    this.empresaService.getInstancias().subscribe({
      next: (data) => {
        this.instancias = data;
      },
      error: (error) => {
        this.toastService.erro("Erro", "Erro ao carregar as empresas");
      }

    })
  }

  change(event: any){
    this.funcaoChange.emit(event);
  }

  eUnico(): boolean {
    return this.modo === 'unico'
  }

  fnOnPanelHide(event: any){
    this.onPanelHide.emit(event);
  }

}
